var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullscreenExit = function SvgFullscreenExit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16C20 15.4477 19.5523 15 19 15H17C16.0572 15 15.5858 15 15.2929 15.2929C15 15.5858 15 16.0572 15 17V19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19V17H19C19.5523 17 20 16.5523 20 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15H7C7.94281 15 8.41421 15 8.70711 15.2929C9 15.5858 9 16.0572 9 17V19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19V17H5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 7.44772 4.44772 7 5 7H7V5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V7C9 7.94281 9 8.41421 8.70711 8.70711C8.41421 9 7.94281 9 7 9H5C4.44772 9 4 8.55228 4 8Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V7H19C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9H17C16.0572 9 15.5858 9 15.2929 8.70711C15 8.41421 15 7.94281 15 7V5C15 4.44772 15.4477 4 16 4Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullscreenExit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fullscreen-exit.600adb2a070fd93dcb38beae062797ef.svg";